<template>
  <v-container fluid class="px-1">
    <v-row align="center">
      <v-col cols="12">
        <div class="d-flex align-start align-sm-center justify-space-between flex-column flex-sm-row entity-wrapper px-md-2">
          <div class="black--text text--darken-6 text-h2 text-md-h1 pt-2 pt-sm-5 pb-5 custom-title">
            <span
              class="cursor-pointer"
              v-tooltip="{
                content: title,
                placement: 'top-end',
              }"
            >
              {{ title }}</span>
            <div class="form-block-subtitle mt-2 text-pre-wrap">
              <slot name="subtitle">{{ subtitle }}</slot>
            </div>
          </div>
          <div v-if="isShowActions" class="d-flex justify-center justify-sm-end flex-column flex-sm-row entity-btns">
            <slot name="actions">
              <slot name="leftActions" />

              <div class="d-flex">
                <ui-button
                  v-if="!hideFilter"
                  :class="{ 'filter-open': isFilterActive }"
                  variant="secondary"
                  class="ml-0 mx-0 mb-0 mb-md-0 list-entity-btn filter-btn"
                  @click="onToggleFilter"
                  :w120="!hideDefaultCreate"
                  :w120sm100="hideDefaultCreate"
                >
                  <template #iconLeft>
                    <v-icon size="20">mdi-filter-variant</v-icon>
                  </template>
                  {{ $t('base.filters') }}
                </ui-button>
                <slot name="defaultCreate">
                  <ui-button
                    v-if="!hideDefaultCreate"
                    v-permission="btnCreate.permission"
                    variant="primary"
                    class="list-entity-btn ml-3"
                    w120
                    @click="btnCreate.modal ? $emit('onCreate') : $router.push({ name: btnCreate.path })"
                  >
                    <template #iconLeft>
                      <v-icon size="18">{{ btnCreate.icon || '' }}</v-icon>
                    </template>
                    {{ btnCreate.title }}
                  </ui-button>
                </slot>
              </div>

              <slot name="rightActions" />
            </slot>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="px-md-4 pt-0">
        <slot />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ui-list-entity',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: ''
    },
    isShowActions: {
      type: Boolean,
      default: true,
    },
    isFilterActive: {
      type: Boolean,
      default: false,
    },
    hideFilter: {
      type: Boolean,
      default: false,
    },
    hideDefaultCreate: {
      type: Boolean,
      default: false,
    },
    btnCreate: {
      type: Object,
      default: () => {
        return {
          path: '',
          title: '',
          icon: false,
          permission: {},
          modal: false
        }
      },
    },
  },
  methods: {
    onToggleFilter() {
      this.$emit('toggleFilter')
    },
  },
}
</script>

<style lang="scss">
.custom-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-btn.filter-btn.filter-open {
  background-color: #e4e4e4 !important;
}
.list-entity-btn {
  //width: 165px;
  //width: 48%;
  //width: calc(50% - 6px)!important;
  //@media #{map-get($display-breakpoints, 'sm-and-up')} {
  //  width: 120px;
  //}
  &.filter-btn {
    background-color: white;
  }
}
.entity-btns {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    width: 100%;
  }
}
</style>
